import { ReviewAI } from "../../lib/reviewApi";
import ReviewInput from "./ReviewInput";
import ReviewResult from "./ReviewResult";
import { useState, useCallback, useMemo } from "react";

export default function ReviewPage() {
  const [text, setText] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 언어 감지 (기존 HTML과 통일)
  const lang = useMemo(
    () => (typeof document !== "undefined" && document.documentElement?.lang) || "ko",
    []
  );

  const handleGenerate = useCallback(async () => {
    if (!text.trim()) {
      alert(lang === "zh-CN" ? "请粘贴患者的评论文本。" : "환자 리뷰 텍스트를 붙여넣어 주세요.");
      return;
    }
    setLoading(true);
    setError("");
    setAnswer("");

    try {
      const res = await ReviewAI.reply({ text, tone: "warm", lang });
      setAnswer(res.answer);
      // 선택: 최근 기록 보관
      try {
        localStorage.setItem("review:lastText", text);
        localStorage.setItem("review:lastAnswer", res.answer);
      } catch {}
    } catch (e) {
      setError(e?.message || (lang === "zh-CN" ? "生成失败" : "생성 실패"));
    } finally {
      setLoading(false);
    }
  }, [text, lang]);

  const handleCopy = useCallback(async () => {
    const toCopy = answer || "";
    if (!toCopy) return;
    try {
      await navigator.clipboard.writeText(toCopy);
      alert(lang === "zh-CN" ? "已复制到剪贴板。" : "클립보드에 복사되었습니다.");
    } catch {
      // 구형 브라우저 fallback
      const el = document.createElement("textarea");
      el.value = toCopy; document.body.appendChild(el);
      el.select(); document.execCommand("copy");
      document.body.removeChild(el);
      alert(lang === "zh-CN" ? "已复制到剪贴板。" : "클립보드에 복사되었습니다.");
    }
  }, [answer, lang]);

  return (
    <section>
      <div id="content_title">
        <h2>AI 리뷰 답변 도우미</h2>
        <p>
          환자 리뷰에 진심을 담아 응답하세요.
          <br />
          AI가 리뷰의 뉘앙스를 파악하여 따뜻한 답변 초안을 작성해 드립니다.
        </p>
      </div>

      <div className="content">
        <div>
          <ReviewInput
            value={text}
            onChange={setText}
            onSubmit={handleGenerate}
            loading={loading}
          />
          <ReviewResult
            answer={answer}
            error={error}
            loading={loading}
            onCopy={handleCopy}
          />
        </div>
      </div>
    </section>
  );
}